/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";

import { EndpointModel } from "../../Common/EndpointModel";
import { Panel } from "../../../../ui/components/Panel";
import { BEM, T, useTranslate } from "@adapptio/lib-components";
import { ToolbarCommandButton } from "../../../../ui/components/Toolbar/ToolbarCommandButton";
import { termsEditorEndpointEditor } from "../../../../terms/endpointEditor";
import { Inspector } from "../../../../inspector";

export interface IEndpointEditorSettingsProps {
	model: EndpointModel;
}

export const EndpointEditorEditSettings: React.FunctionComponent<IEndpointEditorSettingsProps> = ({
	model
}) => {
	const t = useTranslate();

	const specModel = model.getModel().props.spec;

	const baseClass = BEM("edt-inspect-panel");

	return (
		<Panel scroll={true}>
			<div className={baseClass.toClassName()}>
				<div className={baseClass.element("header").toClassName()}>
					<div className={baseClass.element("header-info").toClassName()}>
						<span className={baseClass.element("header-info-name").toClassName()}>
							<T domain="editor" term={termsEditorEndpointEditor.endpointSettings.label} />
						</span>
					</div>
				</div>
				<div className={baseClass.element("content").toClassName()}>
					<Inspector label="Settings" group>
						<Inspector model={specModel.constant.props.requireAuthenticatedUser} />
						<Inspector model={specModel.constant.props.timeout} />
					</Inspector>
				</div>
			</div>
		</Panel>
	);
};
